import Consumer from './QueryHelperConsumer'
import generateContextHOC from 'onyx-common/generateContextHOC'

export default generateContextHOC(Consumer, 'resource')
